import { render } from "./AwaitingApprovalComponent.vue?vue&type=template&id=f6948e6c"
import script from "./AwaitingApprovalComponent.vue?vue&type=script&lang=js"
export * from "./AwaitingApprovalComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__